module.exports = __webpack_public_path__ + "img/nav_btn_menu_p.a139e014.png";